export default __webpack_public_path__ + "static/media/warrior_no_data_group2.8268c5da.png";